import _ from 'lodash';

class UserAgentParser {
  constructor() {
    const ua = _.get(window, 'navigator.userAgent', '');

    /**
     * @type {String}
     */
    this.ua = _.lowerCase(ua);

    /**
     * @type {Array.<String>}
     */
    this.browsersIE = ['msie', 'trident'];

    /**
     * @type {Array.<String>}
     */
    this.browsersEdge = ['edge'];

    /**
     * @type {Array.<String>}
     */
    this.browsersFirefox = ['firefox', 'mozilla'];
  }

  /**
   * @return {Boolean}
   */
  isIE() {
    return this.isTargetBrowsers(this.browsersIE);
  }

  /**
   * @return {Boolean}
   */
  isEdge() {
    return this.isTargetBrowsers(this.browsersEdge);
  }

  /**
   * @return {Boolean}
   */
  isFirefox() {
    return this.isTargetBrowsers(this.browsersFirefox);
  }

  /**
   * @param {Array.<String>}
   * @return {Boolean}
   */
  isTargetBrowsers(targetBrowsers) {
    return _.some(targetBrowsers, candidate => _.includes(this.ua, candidate));
  }
}

export default new UserAgentParser();
